/* --------------------------------
[JSファイルの説明]
・gulpで scripts.json の libs の各ファイルを連結し、 /js/libs.js に書き出している
・gulpで scripts.json の scripts の各ファイルを連結＆圧縮し、 /js/scripts.js に書き出している
・HTMLでは上記の libs.js と scripts.js を読み込んでいる
・もしもgulpの環境が無くて更新が困難な場合は、書き出したJSは無視して scripts.json の各ファイルをHTMLで直接読み込んでも動作は可能
-------------------------------- */

//aタグ スムーススクロール
// $(function () {
//   $('a[href^="#"]').click(function () {
//     var speed = 500;
//     var href = $(this).attr("href");
//     var target = $(href == "#" || href == "" ? 'html' : href);
//     var position = target.offset().top;

//     position -= $('.l-header').innerHeight() - 1;

//     $("html, body").animate({ scrollTop: position }, speed, "swing");
//     return false;
//   });
// });


$(function () {
  const $box = $('.akxy2-home-kv__countBox');

  if ($box[0]) {
    // 期限の設定
    var gYear = 2022, // 年
      gMonth = 5, // 月
      gDay = 25, // 日
      gHour = 10, // 時
      gMinute = 0, // 分
      gSecond = 0; // 秒

    var goal = new Date(gYear, gMonth - 1, gDay, gHour, gMinute, gSecond);

    // 使用する変数の宣言
    var currentTime, period,
      cDay, cHour, cMinute, cSecond,
      insert = "";

    // カウントダウンの処理
    function countdown() {

      // 現在から期限日までの差を取得
      currentTime = new Date();
      period = goal.getTime() - currentTime.getTime();

      // 期限を過ぎていない時
      if (period >= 0) {
        // 日数を取得
        cDay = Math.floor(period / (1000 * 60 * 60 * 24));
        period -= (cDay * (1000 * 60 * 60 * 24));

        // 時間を取得
        cHour = Math.floor(period / (1000 * 60 * 60));
        period -= (cHour * (1000 * 60 * 60));

        // 分を取得
        cMinute = Math.floor(period / (1000 * 60));
        period -= (cMinute * (1000 * 60));

        // 秒を取得
        cSecond = Math.floor(period / (1000));
        period -= (cSecond * (1000));

        // 残り日数の書き換え
        $box.eq(0).html(Math.floor(cDay / 10) % 10);
        $box.eq(1).html(Math.floor(cDay / 1) % 10);
        $box.eq(2).html(Math.floor(cHour / 10) % 10);
        $box.eq(3).html(Math.floor(cHour / 1) % 10);
        $box.eq(4).html(Math.floor(cMinute / 10) % 10);
        $box.eq(5).html(Math.floor(cMinute / 1) % 10);
        $box.eq(6).html(Math.floor(cSecond / 10) % 10);
        $box.eq(7).html(Math.floor(cSecond / 1) % 10);

        // カウントダウンの処理を再実行
        setTimeout(countdown, 10);

        // 期限を過ぎた時
      } else {
      }
    }

    // 処理の実行
    countdown();
  }
});

$(function () {
  const $menu = $('.akxy2-p-hd__menu a');

  if ($menu[0]) {
    const $nav = $('.akxy2-p-hd__nav')

    $menu.on('click', function (event) {
      $menu.toggleClass('is-on');
      $nav.toggleClass('is-show');
    });
  }
});

$(function () {
  $('.akxy2-home-design__slick').each(function (index, el) {
    const $slider = $(this);

    $slider.slick({
      arrows: false,
      dots: true
    });
  });
});

$(function () {
  $('.akxy2-home-products__slick').each(function (index, el) {
    const $slider = $(this);
    const $nav = $('.akxy2-home-products__nav a');

    $nav.eq(0).addClass('is-cr');

    $slider.slick({
      arrows: true,
      dots: false
    })
      .on({
        beforeChange: function (event, slick, currentSlide, nextSlide) {
          $nav.removeClass('is-cr').eq(nextSlide).addClass('is-cr');
        }
      });

    $nav.on('click', function (event) {
      $slider.slick('slickGoTo', parseInt($(this).attr('data-prod-nav')) - 1);
    });
  });
});

/*
//モーダル開くとき
$(document).on('opening', '.remodal', function () {
  $('.moviePlayerModal').each(function(index, el) {
      var t = $(this);
      t.append('<iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/' + t.attr('data-video-id') + '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
  });
});

//モーダルが閉じた後
$(document).on('closed', '.remodal', function() {
  $('.moviePlayerModal').each(function(index, el) {
      var t = $(this);
      t.empty();
  });
});
*/


var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
var players = [];

function onYouTubeIframeAPIReady() {
  $('.moviePlayerAuto').each(function (index, el) {
    var t = $(this);
    t.attr('data-player-id', players.length);

    var player = new YT.Player(t[0], {
      height: '360',
      width: '640',
      videoId: t.attr('data-video-id'),
      playerVars: {
        'modestbranding': 1,
        'autohide': 1,
        'controls': 0,
        'showinfo': 0,
        'rel': 0,
        'autoplay': 0,
        'playsinline': 1,
        'loop': 1,
        'playlist': t.attr('data-video-id')
      },
      events: {
        'onReady': onPlayerReady,
        'onStateChange': onPlayerStateChange
      }
    });
    players.push(player);

    function onPlayerStateChange(event) {
      var ytStatus = event.target.getPlayerState();

      // 再生終了したとき
      if (ytStatus == YT.PlayerState.ENDED) {
        event.target.seekTo(0, true);//動画の初めにシーク
        event.target.mute();
        event.target.playVideo();
      }
    }

    // 4. The API will call this function when the video player is ready.
    function onPlayerReady(event) {
      event.target.mute();
      //event.target.playVideo();
    }

    function playVideo() {
      player.mute();
      player.playVideo();
    }

    function stopVideo() {
      player.stopVideo();
    }
  });

  setTimeout(function () {
    $('.moviePlayerModal').each(function (index, el) {
      var t = $(this);
      t.attr('data-player-id', players.length);

      var player = new YT.Player(t[0], {
        height: '360',
        width: '640',
        videoId: t.attr('data-video-id'),
        playerVars: {
          'modestbranding': 1,
          'autohide': 1,
          'controls': 1,
          'showinfo': 0,
          'rel': 0,
          'autoplay': 0,
          'playsinline': 1
        },
        events: {
          'onReady': onPlayerReady,
          'onStateChange': onPlayerStateChange
        }
      });
      players.push(player);

      function onPlayerStateChange(event) {
        /*var ytStatus = event.target.getPlayerState();

        // 再生終了したとき
        if (ytStatus == YT.PlayerState.ENDED) {
          player.mute();
          player.playVideo();
        }*/
      }

      // 4. The API will call this function when the video player is ready.
      function onPlayerReady(event) {
        //event.target.mute();
        //event.target.playVideo();
      }

      function playVideo() {
        player.mute();
        player.playVideo();
      }

      function stopVideo() {
        player.stopVideo();
      }
    });


    /* モーダル開閉時の動画制御 */

    function YoutubeModal(modal) {
      function getPlayer() {
        return players[modal.find('.moviePlayerModal').attr('data-player-id')];
      }
      this.opend = function () {
        const p = getPlayer();
        p.playVideo();
      }
      this.closing = function () {
        const p = getPlayer();
        p.stopVideo();
      }
      this.closed = function () {
        const p = getPlayer();
        p.stopVideo();
      }
    }

    function Mp4Modal(modal) {
      const video = modal.find('video')[0];
      this.opend = function () {
        video.currentTime = 0;
        video.play();
      }
      this.closing = function () {
        if (!video.paused) {
          video.pause();
          video.currentTime = 0;
        }
      }
      this.closed = function () {
        if (!video.paused) {
          video.pause();
          video.currentTime = 0;
        }
      }
    }

    function isYoutubeModal(modal) {
      return !!modal.find('.moviePlayerModal').length;
    }

    $('.remodalMovie, .wrc-remodalMovie').each(function (index, el) {
      var t = $(this);
      var modal = (isYoutubeModal(t)) ? new YoutubeModal(t) : new Mp4Modal(t);
      t.on('opening', function () { });
      t.on('opened', function () { modal.opend(); });
      t.on('closing', function () { modal.closing(); });
      t.on('closed', function () { modal.closed(); });
    });
  }, 100);
}

$(function () {
  $('.akxy2-home-products').each(function (index, el) {
    const $sec = $(this);
    const $btnPlus = $('.akxy2-home-products__btnsPlus a');
    const $slidePlus = $('.akxy2-home-products__slidePlus');
    const $plusClose = $('.akxy2-home-products__plusClose');


    $btnPlus.each(function (index, el) {
      $(this).on('click', function (event) {
        let tar = $(this).attr('data-prod-target');
        let $tar = $slidePlus.filter('[data-prod-id="' + tar + '"]');

        $slidePlus.removeClass('is-cr');
        $tar.addClass('is-cr');
      });
    });

    $plusClose.each(function (index, el) {
      $(this).on('click', function (event) {
        $slidePlus.removeClass('is-cr');
      });
    });
  });
})

$(function () {
  $('.report-sel__slick').each(function (index, el) {
    const $slider = $(this);

    $slider.slick({
      fade: true,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 1000,
      arrows: false,
      dots: true
    });
  });
});